var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modules-tenders-tabs-container" },
    [
      _c(
        "Sticky",
        {
          model: {
            value: _vm.isStickyHeader,
            callback: function ($$v) {
              _vm.isStickyHeader = $$v
            },
            expression: "isStickyHeader",
          },
        },
        [
          _c(
            "ul",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isStickyHeader,
                  expression: "isStickyHeader",
                },
              ],
              staticClass: "tabs hkld-tabs",
              attrs: { id: "sticky-tabs", "data-tabs": "" },
            },
            [
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "tabs-title sticky-tabs-nav",
                    attrs: { id: "tabs-nav" },
                  },
                  [
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "checkVisibility",
                            rawName: "v-checkVisibility",
                          },
                        ],
                        staticClass: "is-active-tab",
                        class: { errorTab: _vm.tabsInvalid.generalInvalid },
                        on: {
                          click: function ($event) {
                            return _vm.navToTab("#tab-general", $event)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("tender.generalTab")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "checkVisibility",
                            rawName: "v-checkVisibility",
                          },
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isTender,
                            expression: "isTender",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.navToTab("#tab-scope", $event)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("tender.scopeTab")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "checkVisibility",
                            rawName: "v-checkVisibility",
                          },
                        ],
                        class: { errorTab: _vm.tabsInvalid.sectionInvalid },
                        on: {
                          click: function ($event) {
                            return _vm.navToTab("#tab-services", $event)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("tender.sectionTab")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "checkVisibility",
                            rawName: "v-checkVisibility",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.navToTab("#tab-attachment", $event)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("tender.attachmentTab")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "checkVisibility",
                            rawName: "v-checkVisibility",
                          },
                        ],
                        class: { errorTab: _vm.tabsInvalid.termsInvalid },
                        on: {
                          click: function ($event) {
                            return _vm.navToTab("#tab-tnc", $event)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("tender.tncTab")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "checkVisibility",
                            rawName: "v-checkVisibility",
                          },
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showQueryTab,
                            expression: "showQueryTab",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.navToTab("#tab-query", $event)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("summary.query.name")))]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "float-right sticky-tender-tab-buttons" },
                  [_vm._t("default")],
                  2
                ),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "create-tender-main" }, [
        _c(
          "ul",
          {
            staticClass: "row tabs hkld-tabs medium-column-5",
            attrs: { id: "tender-tabs", "data-tabs": "" },
          },
          [
            _c("li", { staticClass: "tabs-title is-active column" }, [
              _c(
                "a",
                {
                  directives: [
                    { name: "checkVisibility", rawName: "v-checkVisibility" },
                  ],
                  class: { errorTab: _vm.tabsInvalid.generalInvalid },
                  attrs: { href: "#tab-general" },
                  on: {
                    click: function ($event) {
                      return _vm.syncHighlight(0)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("tender.generalTab")))]
              ),
            ]),
            _vm._v(" "),
            _c(
              "li",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isTender,
                    expression: "isTender",
                  },
                ],
                staticClass: "tabs-title column",
                on: {
                  click: function ($event) {
                    return _vm.syncHighlight(1)
                  },
                },
              },
              [
                _c(
                  "a",
                  {
                    directives: [
                      { name: "checkVisibility", rawName: "v-checkVisibility" },
                    ],
                    attrs: { href: "#tab-scope" },
                  },
                  [_vm._v(_vm._s(_vm.$t("tender.scopeTab")))]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "tabs-title column",
                on: {
                  click: function ($event) {
                    return _vm.syncHighlight(2)
                  },
                },
              },
              [
                _c(
                  "a",
                  {
                    directives: [
                      { name: "checkVisibility", rawName: "v-checkVisibility" },
                    ],
                    class: { errorTab: _vm.tabsInvalid.sectionInvalid },
                    attrs: { href: "#tab-services" },
                  },
                  [_vm._v(_vm._s(_vm.$t("tender.sectionTab")))]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "tabs-title column",
                on: {
                  click: function ($event) {
                    return _vm.syncHighlight(3)
                  },
                },
              },
              [
                _c(
                  "a",
                  {
                    directives: [
                      { name: "checkVisibility", rawName: "v-checkVisibility" },
                    ],
                    attrs: { href: "#tab-attachment" },
                  },
                  [_vm._v(_vm._s(_vm.$t("tender.attachmentTab")))]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "tabs-title column",
                on: {
                  click: function ($event) {
                    return _vm.syncHighlight(4)
                  },
                },
              },
              [
                _c(
                  "a",
                  {
                    directives: [
                      { name: "checkVisibility", rawName: "v-checkVisibility" },
                    ],
                    class: { errorTab: _vm.tabsInvalid.termsInvalid },
                    attrs: { href: "#tab-tnc" },
                  },
                  [_vm._v(_vm._s(_vm.$t("tender.tncTab")))]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showQueryTab,
                    expression: "showQueryTab",
                  },
                ],
                staticClass: "tabs-title column",
                on: {
                  click: function ($event) {
                    return _vm.syncHighlight(5)
                  },
                },
              },
              [
                _c(
                  "a",
                  {
                    directives: [
                      { name: "checkVisibility", rawName: "v-checkVisibility" },
                    ],
                    attrs: { href: "#tab-query" },
                  },
                  [_vm._v(_vm._s(_vm.$t("summary.query.name")))]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "hkld-tabs-content",
            attrs: { "data-tabs-content": "tender-tabs" },
          },
          [
            _c(
              "div",
              {
                staticClass: "tabs-panel is-active",
                attrs: { id: "tab-general" },
              },
              [
                _c(
                  "div",
                  { staticClass: "grey lighten-5" },
                  [_vm._t("general")],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isTender,
                    expression: "isTender",
                  },
                ],
                staticClass: "tabs-panel",
                attrs: { id: "tab-scope" },
              },
              [
                _c(
                  "div",
                  { staticClass: "grey lighten-5" },
                  [_vm._t("scopeOfWork")],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tabs-panel", attrs: { id: "tab-services" } },
              [
                _c(
                  "div",
                  { staticClass: "grey lighten-5" },
                  [_vm._t("itemServices")],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tabs-panel", attrs: { id: "tab-attachment" } },
              [
                _c(
                  "div",
                  { staticClass: "grey lighten-5" },
                  [_vm._t("fileUpload")],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "tabs-panel", attrs: { id: "tab-tnc" } }, [
              _c(
                "div",
                { staticClass: "grey lighten-5" },
                [_vm._t("termsConditions")],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showQueryTab,
                    expression: "showQueryTab",
                  },
                ],
                staticClass: "tabs-panel",
                attrs: { id: "tab-query" },
              },
              [
                _c(
                  "div",
                  { staticClass: "grey lighten-5" },
                  [_vm._t("query")],
                  2
                ),
              ]
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }